import { gql } from '@apollo/client';
/**
 * @const ImportSaleItemVariantsMutation
 * @since 1.0.0
 */
export const ImportSaleItemVariantsMutation = gql `
  mutation ImportSaleItemsMutation($input: ImportSaleItemVariantsInput!) {
    importSaleItemVariants(input: $input)
  }
`;
